import { render, staticRenderFns } from "./BannerAspectRatioListView.vue?vue&type=template&id=237c3fd9&scoped=true"
import script from "./BannerAspectRatioListView.vue?vue&type=script&lang=js"
export * from "./BannerAspectRatioListView.vue?vue&type=script&lang=js"
import style0 from "./BannerAspectRatioListView.vue?vue&type=style&index=0&id=237c3fd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237c3fd9",
  null
  
)

export default component.exports